import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import LazyImage, { LazyImageProps } from "@insite/mobius/LazyImage";
import { LinkPresentationProps } from "@insite/mobius/Link";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { connect } from "react-redux";
import styled, { css } from "styled-components";

type OwnProps = WidgetProps & HasProduct & ReturnType<typeof mapStateToProps>;

const mapStateToProps = (state: ApplicationState) => ({
    variantSelectionCompleted: state.pages.productDetails.variantSelectionCompleted,
});

export interface GAIAProductDetailsProductCertificationsStyles {
    wrapper?: InjectableCss;
    link?: LinkPresentationProps;
    image?: LazyImageProps;
    text?: TypographyPresentationProps;
}

export const productCertificationStyles: GAIAProductDetailsProductCertificationsStyles = {
    wrapper: {
        css: css`
            /* border-top: 1px solid #e5e5e5; */
            padding-top: 8px;
            margin: 15px 0px;
            width: 100%;
        `,
    },
    link: {
        css: css`
            font-family: "LatoBold";
        `,
    },
    image: {
        height: "72px",
        width: "72px",
    },
    text: {
        color: "primary",
        fontFamily: "LibreBaskerville",
        size: 16,
    },
};

const styles = productCertificationStyles;

const CertificationListContainer = styled.ul`
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
`;

const CertificationListItem = styled.li`
    display: flex;
    flex-direction: column;
    align-items: center;
`;

const GAIAProductDetailsProductCertifications: React.FC<OwnProps> = ({ product, variantSelectionCompleted }) => {
    if (!product) {
        return null;
    }
    const { properties } = product;
    return (
        <StyledWrapper {...styles.wrapper}>
            <CertificationListContainer>
                {properties.vegan === "true" && (
                    <CertificationListItem>
                        <LazyImage
                            src="/UserFiles/Images/ProductDetails/Vegan_200x200.jpg?width=100&height=100"
                            {...styles.image}
                        />
                        <Typography {...styles.text}>Vegan</Typography>
                    </CertificationListItem>
                )}
                {properties.soyFree === "true" && (
                    <CertificationListItem>
                        <LazyImage
                            src="/UserFiles/Images/ProductDetails/Soy-Free_200x200.jpg?width=100&height=100"
                            {...styles.image}
                        />
                        <Typography {...styles.text}>Soy Free</Typography>
                    </CertificationListItem>
                )}
                {properties.dairyFree === "true" && (
                    <CertificationListItem>
                        <LazyImage
                            src="/UserFiles/Images/ProductDetails/Dairy-Free_200x200.jpg?width=100&height=100"
                            {...styles.image}
                        />
                        <Typography {...styles.text}>Dairy Free</Typography>
                    </CertificationListItem>
                )}

                {properties.glutenFree === "true" && (
                    <CertificationListItem>
                        <LazyImage
                            src="/UserFiles/Images/ProductDetails/Gluten-Free_200x200.jpg?width=100&height=100"
                            {...styles.image}
                        />
                        <Typography {...styles.text}>Gluten Free</Typography>
                    </CertificationListItem>
                )}
                {properties.purityTested && (
                    <CertificationListItem>
                        <LazyImage
                            src="/UserFiles/Images/ProductDetails/Purity-Tested_200x200.jpg?width=100&height=100"
                            {...styles.image}
                        />
                        <Typography {...styles.text}>Purity Tested</Typography>
                    </CertificationListItem>
                )}
            </CertificationListContainer>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(withProduct(GAIAProductDetailsProductCertifications)),
    definition: {
        displayName: "GAIA Product Certifications",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
